export const utf8_to_b64 = (str: string) => {
    // 1 & 2: Use TextEncoder to get bytes and then map to characters
    const bytes = new TextEncoder().encode(str);
    // @ts-ignore
    const binString = String.fromCodePoint(...bytes);

    // 3: Base64 encode the binary string
    return btoa(binString);
}

export const b64_to_utf8 = (b64: any) => {
    return b64
    // 2. Create a byte array from the binary string
    // @ts-ignore
    const bytes = Uint8Array.from(b64, (char) => char.codePointAt(0));

    // 3. Use TextDecoder to decode the bytes as UTF-8
    return new TextDecoder().decode(bytes);
}

export function decodeBase64ToUTF8(base64String: string) {
    // 1. Decode Base64 to a standard binary string using atob
    const binaryString = atob(base64String);

    // 2. Convert the binary string to a Uint8Array (array of UTF-8 bytes)
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        // charCodeAt gets the byte value (since the binary string is 1 char = 1 byte)
        bytes[i] = binaryString.charCodeAt(i);
    }

    // 3. Use TextDecoder to convert the UTF-8 bytes into a JavaScript string (UTF-16)
    // This is the step that correctly interprets multi-byte characters like ą, ć, ź.
    const decoder = new TextDecoder('utf-8');
    return decoder.decode(bytes);
}